import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initializePlatform } from './services/platform'
import './index.css'
import './i18n/config'
import App from './App.tsx'

// Initialize platform adapters before store hydration
initializePlatform();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
